module.exports = __webpack_public_path__ + "static/media/external-icon.9de84e86.svg";